import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
const routes: Routes = [
  {
    path: 'dashboard',
    loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule)
  },
  {
    path: 'discovery',
    loadChildren: () => import('./dashboard/discovery/discovery/discovery.module').then(m => m.DiscoveryModule)

  },
  {
    path: 'security',
    loadChildren: () => import('./security/security.module').then(m => m.SecurityModule)

  },
  {
    path: 'datatypes',
    loadChildren: () => import('./data-types/data-types.module').then(m => m.DataTypesModule)

  },
  {
    path: 'ingestion_management',   
    loadChildren: () => import('./ingestion-management/ingestion-management.module').then(m => m.IngestionManagementModule)

  },
 
  { path: 'debugmode', loadChildren: () => import('./debug-mode/debug-mode.module').then(m => m.DebugModeModule) }

];


@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
